import { render, staticRenderFns } from "./recordingDail.vue?vue&type=template&id=045f36ab&scoped=true&"
import script from "./recordingDail.vue?vue&type=script&lang=ts&"
export * from "./recordingDail.vue?vue&type=script&lang=ts&"
import style0 from "./recordingDail.vue?vue&type=style&index=0&id=045f36ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f36ab",
  null
  
)

export default component.exports